












import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class AccessibleBottomSheet extends Vue {
  @Prop({ default: "" }) ariaLabel!: string;

  get sheetRef(): string {
    return `accessible_bottom_sheet_${(this as any)._uid}`;
  }

  // Pass all $attrs except aria-label (we handle it ourselves) to v-bottom-sheet
  get sheetAttrs(): Record<string, any> {
    const { "aria-label": _, ...rest } = this.$attrs as any;
    return rest;
  }

  get isOpen(): boolean {
    return !!this.$attrs.value;
  }

  @Watch("isOpen")
  onValueChange(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        this.applyAriaLabel();
      });
    }
  }

  mounted() {
    if (this.isOpen) {
      this.$nextTick(() => {
        this.applyAriaLabel();
      });
    }
  }

  private applyAriaLabel() {
    if (!this.ariaLabel) return;
    const ref = this.$refs[this.sheetRef] as any;
    if (!ref) return;

    // VBottomSheet extends VDialog. Vuetify renders:
    //   <div role="dialog" class="v-dialog__content">   ← aria-label must go here
    //     <div class="v-dialog v-bottom-sheet">          ← ref.$refs.dialog points here
    // So we go up one level from the inner dialog element to reach role="dialog".
    const innerEl = ref.$refs && ref.$refs.dialog;
    const dialogEl: Element | null = innerEl ? innerEl.parentElement : null;

    if (dialogEl && dialogEl.getAttribute("role") === "dialog") {
      dialogEl.setAttribute("aria-label", this.ariaLabel);
      dialogEl.removeAttribute("aria-labelledby");
    }
  }
}
